import { render, staticRenderFns } from "./SwitchVcDemo.vue?vue&type=template&id=86a620d6&scoped=true&"
import script from "./SwitchVcDemo.vue?vue&type=script&lang=js&"
export * from "./SwitchVcDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a620d6",
  null
  
)

export default component.exports